// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_tbu","cls2":"ProfileDropdown-cls2_eAn ProfileDropdown-cls1_tbu"};